// Auto-generated - DO NOT EDIT
export const pathMapping = {
  "get:/wello/v1/allows/theme/monthly": "findMonthlyThemes",
  "get:/wello/v1/allows/theme/{themeId}/article": "findThemeArticles",
  "get:/wello/v1/allows/theme/{themeId}/festival": "findThemeFestivals",
  "get:/wello/v1/allows/tour/article/{articleId}": "findArticle",
  "get:/wello/v1/allows/tour/article/{articleId}/feedback": "findArticleFeedback",
  "get:/wello/v1/allows/tour/festival/{tourId}": "findTourFestival",
  "get:/wello/v1/allows/tour/festival/{tourId}/review": "findTourReviews",
  "get:/wello/v1/allows/tour/lcls-systm-code": "findTourLclsSystmCodeList",
  "get:/wello/v1/allows/tour/review/good-point-types": "findGoodPointTypes",
  "post:/wello/v2/allows/api-counsel": "createApiCounsel",
  "get:/wello/v2/allows/api-policy": "getApiPolicyList",
  "get:/wello/v2/allows/api-policy/name": "getApiPolicyNameList",
  "get:/wello/v2/allows/api-product/name": "getApiProductNameList",
  "get:/wello/v2/allows/api-theme": "getApiThemeList",
  "get:/wello/v2/allows/api-theme/keyword/name": "getApiThemeKeywordNameList",
  "get:/wello/v2/allows/api-theme/name": "getApiThemeNameList",
  "get:/wello/v2/allows/api-theme/{apiThemeId}": "getApiTheme",
  "get:/wello/v2/allows/benefit-lottery/pool": "findBenefitLotteryPool",
  "get:/wello/v2/allows/benefit-menus": "findBenefitMenuList",
  "get:/wello/v2/allows/best-contents-tag": "findBestContentsTagList",
  "post:/wello/v2/allows/blocklist/reset": "commonCodeInit1",
  "get:/wello/v2/allows/community/wello-news": "getCommunityWelloNewsList",
  "get:/wello/v2/allows/community/wello-news/feedback/{communityIdIdx}": "feedbackCommunityWelloNews",
  "get:/wello/v2/allows/community/wello-news/{communityIdIdx}": "getCommunityWelloNews",
  "get:/wello/v2/allows/contents/best/feedback/{bestContentsId}": "bestContentsFeedback",
  "get:/wello/v2/allows/contents/best/{bestContentsIdIdx}": "getBestContents",
  "get:/wello/v2/allows/control-managements": "getControlManagements",
  "get:/wello/v2/allows/cs/faq": "faqList",
  "get:/wello/v2/allows/cs/notice": "noticeList1",
  "get:/wello/v2/allows/cs/notice/{noticeId}": "notice",
  "get:/wello/v2/allows/emergency-room": "getEmergencyRoomList",
  "get:/wello/v2/allows/emergency-room/code": "getEmergencyRoomCodeList",
  "get:/wello/v2/allows/emergency-room/count": "getEmergencyRoomListCount",
  "get:/wello/v2/allows/emergency-room/region": "getEmergencyRoomRegionList",
  "get:/wello/v2/allows/emergency-room/{emergencyRoomId}": "getEmergencyRoom",
  "get:/wello/v2/allows/emergency-room/{emergencyRoomId}/live": "getEmergencyRoomLive",
  "post:/wello/v2/allows/external/adison-offerwall": "callback1",
  "get:/wello/v2/allows/external/adpopcorn-offerwall/android/callback": "androidCallback",
  "get:/wello/v2/allows/external/adpopcorn-offerwall/ios/callback": "iosCallback",
  "post:/wello/v2/allows/external/kosaf/app-push": "sendAppPush",
  "post:/wello/v2/allows/external/local-market/payments/webhook": "handleNicePayWebhook",
  "post:/wello/v2/allows/external/pincrux-offerwall/callback": "callback",
  "post:/wello/v2/allows/feed": "findFeeds",
  "get:/wello/v2/allows/home-donation-event": "getHomeDonationEvent",
  "get:/wello/v2/allows/home-donation-event-gift-box/invites/top/august-event": "getTopInviterListInAugust",
  "get:/wello/v2/allows/home-donation-event-gift-box/opened/recent": "getRecentOpenedGiftBoxList",
  "get:/wello/v2/allows/home-donation-event-history/invitee-donation/top": "getTopDonationEventHistoryList",
  "get:/wello/v2/allows/home-donation-event-history/member-name": "getMemberNameByInviteCode",
  "get:/wello/v2/allows/home-donation-event-history/reward/recent": "getRecentEventHistoryList",
  "get:/wello/v2/allows/home-donation-event-history/reward/recent/september": "getRecentEventHistoryListInSeptember",
  "get:/wello/v2/allows/home-donation-event/is-progressing": "isEventInProgress",
  "get:/wello/v2/allows/home-donation-guide/calculate": "calculateDonation",
  "get:/wello/v2/allows/home-donation/by-donation-business": "getHomeDonationHistoryByDonationBusinessList",
  "get:/wello/v2/allows/home-donation/statistics": "getHomeDonationStatisticsList",
  "get:/wello/v2/allows/home-inquiry": "getHomeInquiryList",
  "get:/wello/v2/allows/home-inquiry/{homeInquiryId}": "getHomeInquiry",
  "get:/wello/v2/allows/home-love-gov-code/child": "findChildHomeLoveGovCodeList",
  "get:/wello/v2/allows/home-love-gov-code/parent": "findParentHomeLoveGovCodeList",
  "post:/wello/v2/allows/home-love-view": "viewHomeGiftProduct",
  "get:/wello/v2/allows/home-love/donation/complete": "callbackComplete",
  "get:/wello/v2/allows/home-love/main/category-group-gift-products": "findGiftCategoryGroupProductList",
  "get:/wello/v2/allows/home-love/main/daily-pick": "findDailyPickList",
  "get:/wello/v2/allows/home-love/main/featured-donation-businesses": "findFeaturedDonationBusinessList",
  "get:/wello/v2/allows/home-love/main/gift-category-groups": "findGiftCategoryGroupList",
  "get:/wello/v2/allows/home-love/main/institution-specialty": "findHomeInstitutionSpecialtyList",
  "get:/wello/v2/allows/home-love/main/photo-review": "findWeeklyBestPhotoReviewList",
  "get:/wello/v2/allows/home-love/main/popular-gift-products": "findPopularGiftProductList",
  "get:/wello/v2/allows/home-love/main/recent-gift-products": "findRecentGiftProductList",
  "get:/wello/v2/allows/home-notice": "getHomeNoticeList",
  "get:/wello/v2/allows/home-notice/{homeNoticeId}": "getHomeNotice",
  "get:/wello/v2/allows/home-popup-notice": "getHomePopupNotice",
  "get:/wello/v2/allows/home-search-keyword": "getAdminHomeSearchKeywordList",
  "get:/wello/v2/allows/home/donation-business": "getDonationBusinessList",
  "get:/wello/v2/allows/home/donation-business-comment": "getDonationBusinessCommentList",
  "get:/wello/v2/allows/home/donation-business/institution/{institutionId}": "getHomeInstitutionDonationBusiness",
  "get:/wello/v2/allows/home/donation-business/related": "getInstitutionRelatedDonationBusiness",
  "get:/wello/v2/allows/home/donation-business/{donationBusinessId}": "getDonationBusiness",
  "get:/wello/v2/allows/home/donation-business/{donationBusinessId}/detail-count": "getDonationBusinessDetailCount",
  "get:/wello/v2/allows/home/donation-business/{donationBusinessId}/related": "getRelatedDonationBusiness",
  "get:/wello/v2/allows/home/event/december/benefit-amount": "getEventAmountInfo",
  "get:/wello/v2/allows/home/event/december/gift-product": "getDecemberEventGiftProductList",
  "get:/wello/v2/allows/home/event/december/institution-event": "getDecemberInstitutionEventInfoList",
  "get:/wello/v2/allows/home/event/december/random-ticket-winner": "getDecemberRandomTicketWinnerList",
  "get:/wello/v2/allows/home/gift-category": "findGiftCategoryList",
  "get:/wello/v2/allows/home/gift-category/roots": "findRootGiftCategoryList",
  "get:/wello/v2/allows/home/gift-product": "findGiftProductList",
  "get:/wello/v2/allows/home/gift-product-seo/{productNumber}": "getGiftProductSeo",
  "get:/wello/v2/allows/home/gift-product/recommend": "findRecommendGiftProduct",
  "get:/wello/v2/allows/home/gift-product/related": "getInstitutionGiftProductList",
  "get:/wello/v2/allows/home/gift-product/{productNumber}": "findGiftProductDetail",
  "get:/wello/v2/allows/home/gift-product/{productNumber}/related": "findRelatedGiftProductList",
  "get:/wello/v2/allows/home/gift-review": "getGiftOrderProductReviewList",
  "get:/wello/v2/allows/home/gift-review/photo": "getGiftOrderProductPhotoReviewListByProduct",
  "get:/wello/v2/allows/home/gift-review/{reviewId}": "getGiftOrderProductReview",
  "get:/wello/v2/allows/home/institution": "findHomeInstitutionList",
  "get:/wello/v2/allows/home/institution-content": "getHomeInstitutionContentList",
  "get:/wello/v2/allows/home/institution-content/{institutionContentId}": "getHomeInstitutionContent",
  "get:/wello/v2/allows/home/institution-event": "getHomeInstitutionEventList",
  "get:/wello/v2/allows/home/institution-event/ordered": "getOrderedHomeInstitutionEventList",
  "get:/wello/v2/allows/home/institution-event/{institutionEventId}": "getHomeInstitutionEvent",
  "get:/wello/v2/allows/home/institution/code-to-id/{homeLoveGovCode}": "getHomeLoveGovCodeToId",
  "get:/wello/v2/allows/home/institution/for-search-filter": "getHomeInstitutionListForSearchFilter",
  "get:/wello/v2/allows/home/institution/policy": "getHomeInstitutionPolicyList",
  "get:/wello/v2/allows/home/institution/{homeLoveGovCode}/benefit": "getHomeInstitutionBenefitList",
  "get:/wello/v2/allows/home/institution/{homeLoveGovCode}/benefit/all": "getHomeInstitutionBenefitListAll",
  "get:/wello/v2/allows/home/institution/{homeLoveGovCode}/benefit/all/private": "getHomeInstitutionBenefitPrivateList",
  "get:/wello/v2/allows/home/institution/{homeLoveGovCode}/benefit/all/public": "getHomeInstitutionBenefitPublicList",
  "get:/wello/v2/allows/home/institution/{homeLoveGovCode}/region": "getHomeInstitutionBenefitRegionList",
  "get:/wello/v2/allows/home/institution/{institutionId}": "getHomeInstitution",
  "get:/wello/v2/allows/hometown-news/feedback/{hometownNewsId}": "hometownNewsFeedback",
  "get:/wello/v2/allows/hometown-news/{hometownNewsIdIdx}": "hometownNews",
  "get:/wello/v2/allows/hometown-news/{hometownNewsIdIdx}/related": "getRelatedHometownNewsList",
  "get:/wello/v2/allows/interest-policy": "allowsInterestPolicyList",
  "post:/wello/v2/allows/kb": "joinEvent",
  "delete:/wello/v2/allows/kb-pay": "resignWelloWithKbPay",
  "post:/wello/v2/allows/kb-pay/login": "loginWelloWithKbPay1",
  "get:/wello/v2/allows/local-festa/institution-specialty": "getInstitutionSpecialtyList",
  "get:/wello/v2/allows/local-market/coupons/downloadable": "findGeneralDownloadableCoupons",
  "get:/wello/v2/allows/local-market/gift-review-feed/{productId}": "getGiftReviewFeed",
  "post:/wello/v2/allows/local-market/payments/auth-result": "handleAuthResult",
  "get:/wello/v2/allows/local-market/product-feeds": "getProductFeedList",
  "get:/wello/v2/allows/local-market/products/by-product-number/{productNumber}": "getProductDetailByProductNumber",
  "get:/wello/v2/allows/local-market/products/by-product-number/{productNumber}/seo": "getProductSeo",
  "get:/wello/v2/allows/local-market/products/{productId}": "getProductDetail",
  "get:/wello/v2/allows/local-market/products/{productId}/inquiries": "findAllInquiries",
  "get:/wello/v2/allows/local-market/products/{productId}/inquiries/{inquiryId}": "findInquiry",
  "get:/wello/v2/allows/local-market/products/{productId}/reviews": "findReviews",
  "get:/wello/v2/allows/local-market/products/{productId}/reviews/photos": "findPhotoReviews",
  "get:/wello/v2/allows/local-market/products/{productId}/reviews/{reviewId}": "findReview",
  "get:/wello/v2/allows/local-market/products/{productId}/seo": "getProductSeoByProductId",
  "get:/wello/v2/allows/log-term/{termCategory}": "termHistory",
  "get:/wello/v2/allows/maintenance/active": "getActiveMaintenanceList",
  "get:/wello/v2/allows/maintenance/check/{id}": "getMaintenance",
  "get:/wello/v2/allows/median-income": "getMedianIncomeList",
  "delete:/wello/v2/allows/member": "resignMember",
  "post:/wello/v2/allows/member-oauth/before/sns/login": "welloBeforeLogin",
  "get:/wello/v2/allows/member-oauth/kb-member-login-type": "getKbMemberLoginTypeList1",
  "post:/wello/v2/allows/member-oauth/sns/login": "loginWelloSnsMember1",
  "get:/wello/v2/allows/member-oauth/sns/refresh-token": "snsRefreshToken1",
  "get:/wello/v2/allows/member-wello/nickname": "noticeList",
  "put:/wello/v2/allows/message-reject/member-wello": "rejectMessage",
  "get:/wello/v2/allows/meta-code": "metaCodeAll",
  "post:/wello/v2/allows/meta-code/reset": "commonCodeInit",
  "get:/wello/v2/allows/nice-safe-key/check-plus_success": "checkPlusSuccess",
  "get:/wello/v2/allows/non-member-suggest-policy": "getNonMemberSuggestPolicyList",
  "get:/wello/v2/allows/nonsan-roulette": "findNonsanRoulette",
  "get:/wello/v2/allows/point-market/product": "getPointMarketProductList",
  "get:/wello/v2/allows/point-market/product/by-brand": "getPointMarketProductListByBrand",
  "get:/wello/v2/allows/point-market/product/daou": "findDaouProductList",
  "get:/wello/v2/allows/point-market/product/{productIdIdx}": "getPointMarketProduct",
  "post:/wello/v2/allows/point-market/product/{productIdIdx}/feedback": "feedbackPointMarketProduct",
  "get:/wello/v2/allows/policy-case/category": "getListPolicyCaseCategory",
  "get:/wello/v2/allows/policy-code-geocoding": "getPolicyCodeGeocodingList",
  "get:/wello/v2/allows/policy-dictionary": "getPolicyDictionaryList",
  "get:/wello/v2/allows/policy/feedback/{policyId}": "metaPolicyFeedback",
  "get:/wello/v2/allows/policy/popular": "popularPolicyList",
  "get:/wello/v2/allows/policy/{metaPolicyIdIdx}": "metaPolicy",
  "put:/wello/v2/allows/policy/{metaPolicyIdIdx}/ai": "updatePolicyAiInfo",
  "get:/wello/v2/allows/query/best-contents": "findBestContents",
  "get:/wello/v2/allows/query/donations-businesses": "findDonationBusinesses",
  "get:/wello/v2/allows/query/gift-products": "findGiftProducts",
  "get:/wello/v2/allows/query/hometown-news": "findHometownNews",
  "get:/wello/v2/allows/query/integrated": "findIntegrated",
  "get:/wello/v2/allows/query/local-market": "findLocalMarketProducts",
  "get:/wello/v2/allows/query/policies": "findPolicies",
  "get:/wello/v2/allows/query/policies/codes/age": "findQueryAgeCode",
  "get:/wello/v2/allows/query/policies/codes/job": "findQueryJobCode",
  "get:/wello/v2/allows/query/policies/codes/provision": "findQueryProvisionCode",
  "get:/wello/v2/allows/query/policies/codes/target": "findQueryTargetCode",
  "get:/wello/v2/allows/query/tour/festival": "findTourFestivals",
  "post:/wello/v2/allows/s3": "fileUpload",
  "put:/wello/v2/allows/s3": "updateFileTempSaveYn",
  "delete:/wello/v2/allows/s3": "fileDelete",
  "get:/wello/v2/allows/s3/nonmember-decryption": "fileDecryptionDownload",
  "get:/wello/v2/allows/term/{termCategory}": "term",
  "get:/wello/v2/allows/tour/feedback/{tourId}": "findTourFeedback",
  "get:/wello/v2/allows/tour/{tourId}/distance": "findTourDistance",
  "get:/wello/v2/allows/trend": "findTrend",
  "get:/wello/v2/allows/url-mapping/{id}": "getUrlMapping",
  "get:/wello/v2/allows/wello-app-push": "welloAppPushList",
  "put:/wello/v2/allows/wello-app-push": "updateWelloAppPushRead",
  "get:/wello/v2/allows/wello-app-push/count": "newWelloAppPushCnt",
  "post:/wello/v2/allows/wello-app-push/ext": "sendExtAppPush",
  "post:/wello/v2/allows/wello-app-push/{welloAppPushReceiverId}": "updateWelloAppPushRead1",
  "get:/wello/v2/allows/wello-comment": "getMetaPolicyCommentList",
  "get:/wello/v2/allows/wello-comment/live": "getLiveWelloCommentList",
  "get:/wello/v2/allows/wello-comment/{welloCommentId}": "getMetaPolicyCommentList1",
  "post:/wello/v2/allows/wello-device-info": "saveAllowsWelloDeviceInfo",
  "get:/wello/v2/allows/wello-device-info/message-receive": "messageReceive",
  "put:/wello/v2/allows/wello-device-info/message-receive": "updateMessageReceive",
  "post:/wello/v2/allows/wello-nonmember-region": "saveWelloNonmemberRegion",
  "get:/wello/v2/allows/wello-policy-code": "welloPolicyCodeList",
  "get:/wello/v2/allows/wello-policy-code/all": "welloPolicyCodeAllList",
  "get:/wello/v2/allows/wello-policy-code/baby": "welloPolicyCodeBabyList",
  "get:/wello/v2/allows/wello-policy-code/kb": "kbWelloPolicyCodeAllList",
  "get:/wello/v2/allows/wello-policy-code/reverse-geocoding": "reverseGeocoding",
  "get:/wello/v2/allows/wello-quick-menu": "getWelloQuickMenuList",
  "post:/wello/v2/allows/wello-track": "saveWelloTracking",
  "post:/wello/v3/allows/kb-pay/login": "loginWelloWithKbPay",
  "get:/wello/v3/allows/member-oauth/kb-member-login-type": "getKbMemberLoginTypeList",
  "post:/wello/v3/allows/member-oauth/sns/login": "loginWelloSnsMember",
  "get:/wello/v3/allows/member-oauth/sns/refresh-token": "snsRefreshToken",
  "post:/wello/v3/allows/signup/complete": "complete",
  "post:/wello/v3/allows/signup/init": "init",
  "post:/wello/v3/allows/signup/integrate": "integrate",
  "post:/wello/v3/allows/signup/nickname-consent": "saveNicknameConsent",
  "post:/wello/v3/allows/signup/verify": "verify"
} as const;
